__turbopack_context__.v({
  "calendar": "component-module__dgU7TW__calendar",
});
